import { render } from "./ArdaItem.vue?vue&type=template&id=23ae0bd8"
import script from "./ArdaItem.vue?vue&type=script&lang=js"
export * from "./ArdaItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__